// extracted by mini-css-extract-plugin
module.exports = {"dateContainer":"AssignmentDetailEditDate_dateContainer__2geFY","dateText":"AssignmentDetailEditDate_dateText__LY0Va","dateInput":"AssignmentDetailEditDate_dateInput__39wcQ"};